/* pantallas-alumno (B): EL AVISO "YOU NEED A CONNECTION" (4.1 del encargo, "App sin red").

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Donde un control va "apagado sin red", se ve al 38 o 45 %, no navega ni manda nada, y al tocarlo
   sale el aviso de hoy: `common:offline.need_connection`, como aviso de error (el mismo que dan el
   Panel y la ventana de Rename). La red se lee con el detector que ya usa la app:
   `hooks/useNetworkStatus.js` (`isOffline` solo es verdadero con un dictamen de "sin red"). El `id`
   hace que tocar varias veces no apile avisos iguales. */
import { toast } from 'sonner';

export const AVISO_SIN_RED_ID = 'alumno-sin-conexion';

export function avisarSinRed(t, id = AVISO_SIN_RED_ID) {
  toast.error(t('common:offline.need_connection'), { id });
}
